import BaseView from './BaseView';
let view = null;

class TemplateArticles extends BaseView {
	constructor(container) {
		super(container);
	}

    init() {
	}

	destroy() {
	}
}

export default {
	namespace: 'template-articles',
	beforeEnter: ({ current, next, trigger }) => {
		view = new TemplateArticles(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
